<template>
    <!--<div class="d-flex justify-content-center" v-if="loadingSpinner" style="color:red; text-align:center">-->
    <!--<div class="item-1"></div>
    <div class="item-2"></div>
    <div class="item-3"></div>
    <div class="item-4"></div>
    <div class="item-5"></div>-->
    <!--<div class="loader">
            <div class="square-spin">
                <div><img src="../assets/img/A-White.svg"></div>
            </div>
        </div>
    </div>-->
    <div v-if="!loadingSpinner">
        <header class="d-md-flex d-sm-block justify-content-between text-md-left text-center p-3">
            <template v-if="isgeo == 1">
                <img src="../../assets/img/logo-wh.svg" width="170" class="">
            </template>
            <template v-else>
                <img src="../../assets/img/logoEn.png" height="80" class="mt-3">
            </template>

            <div :class="[{'font-size-for-eng mt-2 mb-3': $t('isgeo') == 0},'text-right font-weight-bold title important-title mt-2']"  v-html="$t('importantheadertext')">
            </div>

        </header>
        <div style="background-color: #bd9bc5 ; height:10px;"> </div>
        <main :class="[{'font-size-for-eng': $t('isgeo') == 0},{'font-size-for-ge': $t('isgeo') == 1}]">
            <div class="text-center mt-3 font-weight-bolder"></div>
            <b-row class="m-0">
                <b-col cols="12" class="text-center font-weight-bolder">
                    {{$t('importantextvit',{policy: policy})}}
                </b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    {{$t('insurancefullname')}}
                </b-col>
                <b-col md="6" sm="12" class="mt-2 green-text font-weight-bold">{{$t('JSCardi')}}</b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">{{$t('insuranceface')}}</b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold">{{$t('healthinsurance')}}</b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    {{$t('exceptionalconditions')}}
                </b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold">{{$t('article#2')}}</b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="vertical-center">
                        {{$t('obligationsinsurer')}}
                    </div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold" v-html="$t('articles')">

                </b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    {{$t('termoftheinsurancecontract')}}
                </b-col>
                <b-col md="6" sm="12" class="mt-2 row">
                    <div class="green-box col-md-3 col-6 p-3 ">{{$t('from')}}</div>
                    <div class="p-3 col-md-3 col-6 pl-lg-1 pl-md-1">{{start}}</div>
                    <div class="green-box col-md-3 col-6 p-3 pl-lg-1 pl-md-1">{{$t('including')}}</div>
                    <div class="p-3 col-md-3 col-6">{{end}}</div>
                </b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="">{{$t('gettingreimbursement')}}</div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold">
                    {{$t('article#3')}}
                </b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="vertical-center">{{$t('cancelingagreement')}}</div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2 font-weight-bold" v-html="$t('articles2')">
                </b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="vertical-center">{{$t('ruleforfiling')}}</div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2" v-html="$t('mainrule')">

                </b-col>

                <b-col md="6" sm="12" class="mt-2 font-weight-bolder description-box-c ">
                    <div class="vertical-center">
                        {{$t('nameaddresssupervisory')}}
                    </div>
                </b-col>
                <b-col md="6" sm="12" class="mt-2">
                    {{$t('statesupervisionaddress')}}
                </b-col>

            </b-row>
        </main>
        <risk :polid="polid" :riskdata="riskdata" />
    </div>
</template>

<script>
    import Risk from "@/Medical/components/Risk";
    export default {
        name: "ImportantConditions",
        props: ['policy', 'start', 'end', 'polid', 'isgeo'],
        components: {
            Risk
        },
        data() {
            return {
                data: null,
                riskdata: null,
                isGeo: this.isgeo,
                loadingSpinner: true,
                cont: this.$route.params.cont,
                cust: this.$route.params.cust,
            }
        },
        mounted() {
            this.$http.get(`/policy/GetVitaminRiskInfo/${this.cont}/${this.cust}/${this.polid}`).then(r => {
                this.riskdata = r.data;
                this.loadingSpinner = false;
                console.log("riskdata", r.data);
            }).catch((e) => {
                console.log(e)
            })
        }
    }
</script>

<style scoped>

    header {
        background: #007a60 !important;
        color: #fafafa;
        /*box-shadow: 0 10px 0 #bd9bc5;*/
    }

    .title {
        font-size: 18px;
    }

    .description-box-c {
        background: #e6e0ea !important;
        color: black !important;
    }

    .green-text {
        color: #00A886;
    }

    .text-size {
        font-size: 14px;
    }

    .green-box {
        background: #007a60 !important;
        color: #fafafa;
    }

    .content-header {
        background-color: #D0AAD9;
        color: #fff;
        font-size: 14px;
    }

    .description {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
    }


    .gray-box {
        background-color: #dedede;
    }

    .green-dorder-right {
        border-right: 1px solid #00A788;
    }

    .green-dorder-left {
        border-left: 1px solid #00A788;
    }

    .dorder-left-right-bottom {
        border-left: 1px solid #00A788;
        border-right: 1px solid #00A788;
        border-bottom: 1px solid #00A788;
    }

    .dorder-bottom-inside {
        border-bottom: 1px solid #00A788;
    }

    .dorder-right-inside {
        border-right: 1px solid #00A788;
    }


    .dorder-rgh-bot-inside {
        border-bottom: 1px solid #00A788;
        border-right: 1px solid #00A788;
    }

    .green-border {
        border-collapse: collapse;
        border-bottom: 1px solid #00A788;
        border-right: 1px solid #00A788;
    }

    .value-border {
        border-bottom: 1px solid #00A788;
        border-right: 1px solid #00A788;
    }

    .text-size-1 {
        font-size: 25px;
        font-weight: bold;
    }
     @media print {
        .font-size-for-eng {
            font-size: 25px !important;
        }
        .font-size-title-for-eng {
            font-size: 21px !important;
        }
        .font-size-for-ge {
            font-size: 23px !important;
        }
        
    }
    @media (max-width: 500px) {
        .important-title {
            font-size: 16px;
            text-align: center !important;
        }

        .title {
            font-size: 15px;
        }
    }
</style>